<template>
  <div class="dtv-card-container">
    <div class="dtv-card">
      <div class="dtv-card__content">
        <slot />
      </div>
      <nav class="dtv-card__actions">
        <div class="dtv-card__actions-start">
          <slot name="actions-start" />
        </div>
        <div class="dtv-card__actions-center">
          <slot name="actions-center" />
        </div>
        <div class="dtv-card__actions-end">
          <slot name="actions-end" />
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.dtv-card-container {
  --padding-inline: var(--dtv-card-padding-inline, var(--sp-comp-dtv-card-padding-inline, 6rem));
  --padding-block: var(--dtv-card-padding-block, var(--sp-comp-dtv-card-padding-block, 3rem));
  --card-gap: var(--sp-comp-dtv-card-gap, 2rem);
  --card-inline-max-size: var(--sp-comp-dtv-card-inline-max-size, 60ch);
  --card-max-width: calc(var(--padding-inline) * 2 + var(--card-inline-max-size));
  --card-box-shadow: var(
    --sp-comp-dtv-card-box-shadow,
    var(--dtv-card-box-shadow, 0 0.06rem 1.25rem 0.06rem rgba(0, 0, 0, 0.1), 0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.05))
  );
  --card-border-radius: var(--sp-comp-dtv-card-border-radius, 0);
  --card-border-width: var(--sp-comp-dtv-card-border-width, 0);
  --card-border: var(--card-border-width) var(--sp-comp-dtv-card-border-style, solid)
    var(--sp-comp-dtv-card-border-color, #ccc);

  width: 100%;
  display: flex;
  justify-content: center;
  padding-inline: var(--sp-comp-dtv-card-container-padding-inline, clamp(0.25rem, 3vw, var(--card-gap)));
  max-width: var(--card-max-width);
}

.dtv-card {
  display: grid;
  grid-template-rows: 1fr auto;
  width: 100%;
  max-width: var(--card-max-width);
  margin: var(--sp-comp-dtv-card-margin, 0);
  padding-block: var(--padding-block);
  padding-inline: var(--padding-inline);
  border: var(--card-border);
  border-radius: var(--card-border-radius);
  background-color: white;
  min-height: var(--dtv-app-content-min-height);
  box-shadow: var(--card-box-shadow);
  &:deep(header) {
    font-family: var(--sp-comp-dtv-card-header-font, inherit);
    font-size: var(--sp-comp-dtv-card-header-font-size, 1.25rem);
    font-weight: var(--sp-comp-dtv-card-header-font-weight, 700);
  }
}

.dtv-card__actions {
  display: grid;
  grid-template-columns: var(
    --dtv-card-actions-grid-columns,
    var(--sp-comp-dtv-card-actions-grid-columns, auto 1fr auto)
  );
  grid-template-areas: var(
    --dtv-card-actions-grid-areas,
    var(--sp-comp-dtv-card-actions-grid-areas, "start-action center-action end-action")
  );
  gap: var(--sp-comp-dtv-card-actions-row-gap, 0.5rem) var(--sp-comp-dtv-card-actions-gap, 0.5rem);
  align-items: center;
  justify-content: space-between;
  margin-top: var(--sp-comp-dtv-card-actions-margin-top, 2rem);
}
.dtv-card__actions-start {
  grid-area: start-action;
}
.dtv-card__actions-center {
  grid-area: center-action;
}
.dtv-card__actions-end {
  grid-area: end-action;
}
</style>
